export default __webpack_public_path__ + "static/media/Testimonial.ed10c1ab.png";